import { render, staticRenderFns } from "./BoostExpiredModal.vue?vue&type=template&id=2dfed980&scoped=true"
import script from "./BoostExpiredModal.vue?vue&type=script&lang=js"
export * from "./BoostExpiredModal.vue?vue&type=script&lang=js"
import style0 from "./BoostExpiredModal.vue?vue&type=style&index=0&id=2dfed980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfed980",
  null
  
)

export default component.exports